import { render, staticRenderFns } from "./need-solution-detail.vue?vue&type=template&id=0ce0ed48&scoped=true&"
import script from "./need-solution-detail.vue?vue&type=script&lang=js&"
export * from "./need-solution-detail.vue?vue&type=script&lang=js&"
import style0 from "./need-solution-detail.vue?vue&type=style&index=0&id=0ce0ed48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce0ed48",
  null
  
)

export default component.exports